module.exports = __webpack_public_path__ + "img/VL_01_03.1f0524d0.png";